module.exports = __webpack_public_path__ + "r-v3/img/icon-schedule-call_white.bb74b842.svg";